import { render, staticRenderFns } from "./IconYesterdayDate.vue?vue&type=template&id=4c140a0c&"
import script from "./IconYesterdayDate.vue?vue&type=script&lang=js&"
export * from "./IconYesterdayDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c140a0c')) {
      api.createRecord('4c140a0c', component.options)
    } else {
      api.reload('4c140a0c', component.options)
    }
    module.hot.accept("./IconYesterdayDate.vue?vue&type=template&id=4c140a0c&", function () {
      api.rerender('4c140a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconYesterdayDate.vue"
export default component.exports